import { faChartLine, faFolderOpen, faWrench } from "@fortawesome/free-solid-svg-icons";
import { faFileLines, faRectangleTerminal } from "@fortawesome/pro-solid-svg-icons";
import { asyncRoute } from "./default";
import { MenuItem } from "./types";

export const commonMenuItems = {
  status: new MenuItem(
    "",
    faChartLine,
    asyncRoute(() => import("../components/views/Status.vue")),
  ),
  settings: new MenuItem(
    "settings",
    faWrench,
    asyncRoute(() => import("../components/views/config/Conf.vue")),
  ),
  console: new MenuItem(
    "console",
    faRectangleTerminal,
    asyncRoute(() => import("../components/views/Console.vue")),
  ),
  logs: new MenuItem(
    "logs",
    faFileLines,
    asyncRoute(() => import("../components/views/Logs.vue")),
  ),
  fileManager: new MenuItem(
    "files",
    faFolderOpen,
    asyncRoute(() => import("../components/views/FileManager.vue")),
  ),
};
